import script from "./OrderTradeType.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrderTradeType.vue?vue&type=script&setup=true&lang=ts"

import "./OrderTradeType.vue?vue&type=style&index=0&id=17e602a8&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17e602a8"]])

export default __exports__